import dynamic from 'next/dynamic';

// Types
import type { UserPublicTokenType } from '@/utils/hooks/swr/integrations/useUserPublicTokens';
import useUserPublicTokens from '@/utils/hooks/swr/integrations/useUserPublicTokens';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Icon from '@/components/base/Icon';
const CreateTokenModal = dynamic(
    () => import('@/components/pages/settings/integrations/Modals/CreateTokenModal')
);

type ButtonEditTokenProps = {
    token: UserPublicTokenType;
};

function ButtonEditToken({ token }: ButtonEditTokenProps) {
    const { isOpen, toggle } = useToggle();
    const { mutateUserPublicTokens } = useUserPublicTokens({
        options: { revalidateIfStale: false }
    });
    return (
        <>
            <button
                className="inline-flex items-center"
                data-testid={`edit-token-${token.id}`}
                onClick={toggle}>
                <Icon icon="edit" className="text-sm text-icoGray-500 dark:text-icoDarkMode-wolf" />
            </button>
            <CreateTokenModal
                isOpen={isOpen}
                toggle={toggle}
                dataToken={token}
                callbackSuccess={async () => {
                    await mutateUserPublicTokens();
                    toggle();
                }}
            />
        </>
    );
}

export default ButtonEditToken;
